import React, { useContext, useState, useEffect } from 'react'
import { isEmpty } from 'lodash'
import { apiGet } from '../../utils/apiFetch'
import pathObj from '../../utils/pathObj'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import CurrencyExchangeEdit from './CurrencyExchangeEdit'

const CurrencyExchange = () => {
  const { logoutUser, updatePageName } = useContext(AuthContext)
  const { t } = useTranslation()
  const [currencyExchangeData, setCurrencyExchangeData] = useState([])
  const [editShowModal, setEditShowModal] = useState(false)
  const [selectedExchangeItem, setSelectedExchangeItem] = useState({})

  const getData = async () => {
    try {
      const res = await apiGet(pathObj.getCurrencyExchanges)
      if (res) {
        setCurrencyExchangeData(res?.data?.results)
      }
    } catch (error) {
      console.log('error:', error)
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    updatePageName(t('NAV_CURRENCY_SETTINGS'))
    getData()
  }, [])

  const initEdit = (item) => {
    setSelectedExchangeItem(item)
    setEditShowModal(true)
  }
  
  return (
    <>
      <div className='p-3'>
        <div className='overflow-x-auto relative rounded-lg border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  {t('CURRENCY')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('CURRENCY_BID')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('CURRENCY_ASK')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('SYSTEM_CURRENCY_BID')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('SYSTEM_CURRENCY_ASK')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
              {
                currencyExchangeData && currencyExchangeData?.map((exchangeData, i) => (
                  <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                    <td className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'>
                      {exchangeData.currency_code_from} {"->"} {exchangeData.currency_code_to}
                    </td>
                    <td className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'>
                      {exchangeData.market_bid_price}
                    </td>
                    <td className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'>
                      {exchangeData.market_ask_price}
                    </td>
                    <td className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'>
                      {exchangeData.company_bid_price}
                    </td>
                    <td className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'>
                      {exchangeData.company_ask_price}
                    </td>
                    
                    <td>
                      <div className='text-center'>
                        <button
                            className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                            type='submit' onClick={() => {
                                initEdit(exchangeData)
                            }}
                          >
                            {t('O_UPDATE')}
                          </button>
                      </div>
                    </td>
                </tr>
                ))
              }

            <tbody>
              {isEmpty(currencyExchangeData) ? (
                <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6 border-r' colSpan={10}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>

          {editShowModal ? (
          <CurrencyExchangeEdit
            setEditShowModal={setEditShowModal}
            itemUpdated={getData}
            item={selectedExchangeItem}
          />
        ) : null}

        </div>
      </div>
    </>
  )
}

export default CurrencyExchange